<template>
  <div :class="s.background" :style="backgroundStyle" v-sound>
    <div :class="s.title">
      <p>ご注文<br>ありがとうございます</p>
      <div :class="s.subtitle">
        <p>ご注文を承りました<br>お料理が届くまで、しばらくお待ちください</p>
      </div>
      <div :class="s.container">
        <button :class="s.closeButton" @click="goToMenu">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['user']),

    backgroundStyle() {
      // ユーザーIDに基づいて背景画像を設定（user_{id}.jpgがあれば使用）
      if (this.user.id) {
        return {
          backgroundImage: `url('/img/backgrounds/user_${this.user.id}.jpg'), url('/img/backgrounds/default.PNG')`,
        };
      }
      return {};
    },
  },
  methods: {
    goToMenu() {
      if (window.innerWidth <= 768) {
        this.$router.push('/menu-mobile');
      } else {
        this.$router.push('/menu');
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.background {
  background-size: cover;       /* 画像を画面全体に拡大 */
  background-position: center;  /* 中央に配置 */
  background-repeat: no-repeat; /* 画像を繰り返さない */
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative; /* 文字を上に配置 */
}

/* ✅ タイトルとメッセージ */
.title {
  color: #fffffff0;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 70px;
  text-align: center;
  font-weight: bold;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5vh;
  z-index: 1; /* 文字を前面に */
  position: relative;
  white-space: nowrap;
}

/* ✅ サブタイトル */
.subtitle {
  color: #FFFFFF;;
  font-family: '游明朝', serif;
  font-size: 32px;
  text-align: center;
  font-weight: bold;
  line-height: 1.4;
  margin-top: 20px;
}

/* ✅ ボタンコンテナ */
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

/* ✅ 閉じるボタン */
.closeButton {
  background-color: #953127;
  color: #FFFFFF;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 36px;
  padding: 12px 50px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  outline: none;
}

.closeButton:hover {
  background-color: #B03A2E;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .title {
    font-size: 40px; /* モバイルでのタイトルサイズ縮小 */
  }
  .subtitle {
    font-size: 20px; /* モバイルでのサブタイトルサイズ縮小 */
  }
  .closeButton {
    font-size: 24px; /* モバイルでのボタン文字サイズ調整 */
    padding: 16px 60px; /* タップしやすいようにパディング調整 */
  }
}
</style>
